export default __webpack_public_path__ + "static/media/collaDepth.b274a21a.jpg";